import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { GddTomatoData } from '../models';

export default class PrincesWidgetsAPI {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getGddTomato(farmId: number, campaign: number, lotId: number): Promise<GddTomatoData>
    {
        const res = await this.http.get('/indexes/api/v1/agrimeteo/hist/gdd/tomato/subjects/' + farmId + '/' + campaign + '/plots/' + lotId);
        return res.data;
    }
}
